import Papa from 'papaparse';
import { downloadFile } from '@/helpers/file';

export const jsonToCsv = (list, fileName, options = { encoding: 'utf-8' }) => {
  let csv = Papa.unparse(list, options);
  downloadFile(csv, fileName);

  return true;
};
